import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import StatusIcon from 'Components/public/modelReleases/StatusIcon';

export default class GalleryOverlayV2 extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(['default']),
        contentArray: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.string.isRequired
            })
        )
    };
    static defaultProps = {
        type: 'default',
        contentArray: []
    }

    render() {
        const { type, contentArray } = this.props;

        return (
            <div className="component-gallery-photo-overlay-v2">
                <div className="overlay-elements">
                    {contentArray.map(contentElem => (
                        <p key={contentElem.label + contentElem.value} className="overlay-element">
                            {contentElem.label ? <span className="label">{contentElem.label}: </span> : null}
                            <span className="value">{contentElem.value}</span>
                        </p>
                    ))}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryOverlayV2/index.js